import * as general from '@/utils/general'

export const URL_DOMAIN = 'https://www.bungie.net';
export const URL_ROOT = URL_DOMAIN + '/Platform';

async function api(path, options = {}) {
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json;charset=UTF-8',
    'X-API-Key': 'e43e3a13a2b54560bde9811073c06415'
  }
  options.headers = headers;

  general.statusMessage('');
  general.debug('API', path);

  const response = await fetch(URL_ROOT + path, options)
    .then(res => {
      general.debug('API', path, res);
      if (!res.ok) {
        let errorMsg = res.status;
        if (res.statusText) errorMsg += ' - ' + res.statusText;
        throw new Error(errorMsg);
      }
      return res.json()
    })
    .then(res => res.Response)
    .catch(error => {
      console.error('API ERROR', path, error);
      general.statusMessage('API ERROR: ' + error, 'error');
    });
  return response;
}

export const getSettings = async () => api('/Settings/');
export const getManifest = async () => api('/Destiny2/Manifest/');
//export const searchDestinyPlayer = async gamerTag => api('/Destiny2/SearchDestinyPlayer/-1/' + encodeURIComponent(gamerTag));
export const searchDestinyPlayer = async gamerTag => api('/User/Search/Prefix/' + encodeURIComponent(gamerTag) + '/0');
export const profile = async (membershipType, membershipId, components) => api(`/Destiny2/${encodeURIComponent(membershipType)}/Profile/${encodeURIComponent(membershipId)}?components=${encodeURIComponent(components)}`);
